import FormattingTooltip from './FormattingTooltip';
export default FormattingTooltip;
